module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "side-menu-toggler",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.toggle($event)
      }
    }
  }, [_c('div', {
    staticClass: "side-menu-toggler-icon mx-auto",
    class: [_vm.hasOverlays ? 'side-menu-toggler-icon-cross' : '']
  }, [_c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span')])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c292b6a6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/LandingHeader/SideMenuToggler.vue
// module id = 636
// module chunks = 1